// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3p5Zr","rightAdornment":"Header_rightAdornment__300Wz"};